<template>
	<div id="om-flyout" :class="menu.active ? 'opened' : ''">
		<div id="om-flyout-items">
			<a
				v-for="(item, i) in menu.items"
				:key="item.title"
				:href="item.url"
				:class="itemClasses(i)"
				target="_blank"
				rel="noopener noreferrer"
			>
				<div class="om-flyout-label">{{ item.title }}</div>
				<i :class="iconClass(item.icon)"></i>
			</a>
			<core-upgrade-button
				v-if="showProUpsells"
				utm-medium="QuickLinks"
				class="om-flyout-item-upgrade"
				:class="itemClasses(menu.items.length)"
				target="_blank"
				:link-style="true"
			>
				<template #successText>
					<div class="om-flyout-label">Upgrade Complete! (Reloading)</div>
					<i class="fa fa-star"></i>
				</template>
				<template #errorText>
					<div class="om-flyout-label">Upgrade incomplete!</div>
					<i class="fa fa-star"></i>
				</template>
				<div class="om-flyout-label">Upgrade to OptinMonster Pro</div>
				<i class="fa fa-star"></i>
			</core-upgrade-button>
		</div>
		<a href="#" class="om-flyout-button om-flyout-head" @click.prevent="showOrHide">
			<div class="om-flyout-label">See Quick Links</div>
			<img :src="archie" alt="See Quick Links" />
		</a>
	</div>
</template>
<script lang="js">
import { mapGetters } from 'vuex';

export default {
	data() {
		const dotOrgSupport = this.$store.getters.showProUpsells;
		return {
			menu: {
				active: false,
				items: [
					{
						title: 'Suggest a Feature',
						url: this.$urls.app(
							'account/support/?topic=feature&utm_source=WordPress&utm_medium=QuickLinks&utm_campaign=Plugin'
						),
						icon: 'fa-lightbulb-o',
					},
					{
						title: 'Join Our Community',
						url: 'https://www.facebook.com/groups/optinmonsterinnercircle/',
						icon: 'fa-comments',
					},
					{
						title: dotOrgSupport ? 'Visit Support Forums' : 'Support & Docs',
						url: dotOrgSupport
							? this.$urls.app('redirect/wp-plugin-support/')
							: this.$urls.docs('', 'QuickLinks'),
						icon: 'fa-life-ring',
					},
				],
			},
		};
	},
	computed: {
		...mapGetters(['showProUpsells']),
		archie() {
			const images = require.context('../../assets/images/', false, /\.svg$/);
			return images(`./${this.menu.active ? '' : 'in'}active-archie.svg`);
		},
	},
	methods: {
		showOrHide() {
			this.menu.active = !this.menu.active;
		},
		itemClasses(i) {
			return `om-flyout-button om-flyout-item om-flyout-item-${i}`;
		},
		iconClass(icon) {
			return `fa ${icon}`;
		},
	},
};
</script>
<style scoped lang="scss">
#om-flyout {
	$start: 75px;
	$step: 55px;
	$trans: 0.2s;
	$delay: 35ms;

	position: fixed;
	z-index: 9998;
	transition: all $trans ease-in-out;
	right: 40px;
	bottom: 40px;
	opacity: 1;

	@media all and (max-width: 960px) {
		display: none;
	}

	.om-flyout-head {
		display: block;

		img {
			background-color: #fff;
			width: 54px;
			height: 54px;
			display: block;
			border-radius: 50%;
			border: 3px solid #a3c47b;
			overflow: hidden;
			box-shadow: 0 3px 20px rgba(0, 0, 0, 0.2);
			transition: all $trans ease-in-out;
		}

		&:hover img {
			box-shadow: 0 3px 30px rgba(0, 0, 0, 0.25);
		}

		.om-flyout-label {
			opacity: 0;
			transform: translateY(-50%) scale(0);
			margin-right: -50px;
		}

		&:hover .om-flyout-label {
			opacity: 1;
			transform: translateY(-50%) scale(1);
			margin-right: 0;
		}

		&:focus {
			box-shadow: none;
		}

		.om-flyout-label {
			right: calc(100% + 15px);
		}
	}

	.om-flyout-label {
		position: absolute;
		display: block;
		top: 50%;
		right: calc(100% + 25px);
		transform: translateY(-50%);
		-moz-transform: translateY(-50%);
		-webkit-transform: translateY(-50%);
		color: #fff;
		background: #5f5e5e 0 0 no-repeat padding-box;
		font-size: 12px;
		white-space: nowrap;
		padding: 5px 10px;
		height: auto !important;
		line-height: initial;
		transition: all $trans ease-out;
		border-radius: 3px;
		-moz-border-radius: 3px;
		-webkit-border-radius: 3px;
	}

	.om-flyout-item {
		position: absolute;
		left: 10px;
		width: 40px;
		height: 40px;
		opacity: 0;
		visibility: hidden;
		transition: all $trans ease-in-out;
		transform: scale(0);
		border-radius: 50%;
		box-shadow: 0 3px 20px rgba(0, 0, 0, 0.2);
		background: #036aab 0 0 no-repeat padding-box;
		text-align: center;
		vertical-align: middle;
		background-color: #007fdb;

		i {
			color: #ffffff;
			font-size: 20px;
			line-height: 40px;
			vertical-align: middle;
		}

		@for $i from 0 through 4 {
			&.om-flyout-item-#{$i} {
				bottom: $start + $i * $step;
			}
		}

		&.om-flyout-item-upgrade {
			background-color: #f86d37;
		}

		&:hover {
			box-shadow: 0 3px 30px rgba(0, 0, 0, 0.25);
			background: #3fa548 0 0 no-repeat padding-box;

			.om-flyout-label {
				background: #444444 0 0 no-repeat padding-box;
			}
		}
	}

	&.opened {
		.om-flyout-item {
			opacity: 1;
			visibility: visible;
			transform: scale(1);
		}

		.om-flyout-head {
			.om-flyout-label {
				display: none;
			}
		}

		@for $i from 0 through 4 {
			.om-flyout-item-#{$i} {
				transition:
					transform $trans $i * $delay,
					background-color $trans;
			}
		}
	}

	&.out {
		opacity: 0;
		visibility: hidden;
	}
}
</style>
